import { render } from "./LoadImageComponent.vue?vue&type=template&id=aa432fb4"
import script from "./LoadImageComponent.vue?vue&type=script&lang=js"
export * from "./LoadImageComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__